export default function FAQItem({props, isExpanded, onClick}) {
    return (
        <div key={props.id} className="faq-item">
            <div
            className={`flex justify-content-start gap-2 faq-item-header ${isExpanded ? "expanded" : ""}`}
            onClick={() => onClick(props.id)}
            >
                <span className="keduall-typography heading-h5-bold-700 text-primary-default">Q.</span> 
                <span className={`w-full word-wrap-break-word keduall-typography heading-h4-${isExpanded ? "semibold-600" : "normal-400"}`}>{props.question}</span>
            <div className="flex justify-content-end">
                <i
                    className={`pi ${isExpanded ? "pi-chevron-up" : "pi-chevron-down"
                    }`}
                />
            </div>
            </div>
            {isExpanded && (
            <div className="flex flex-column gap-2 px-3 pb-3 pt-1">
                <div
                    className="flex flex-column faq-item-answer keduall-typography heading-h5-normal-400 ml-5 word-wrap-break-word"
                    dangerouslySetInnerHTML={{ __html: props.answer }}
                />
            </div>
            )}
        </div>
    );
}